export interface ParseInvitesRequest {
  research_group_id: string;
  emails: string /*csv with columns: email*;first_name;last_name;language (two-letter lowercase ISO, ie. nl|en)*/;
}
